<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="">
        <el-breadcrumb-item
        >
          <div class="div1">基本配置</div>
        </el-breadcrumb-item
        >
        <el-breadcrumb-item
        >
          <div class="div2">短链管理</div>
        </el-breadcrumb-item
        >
      </el-breadcrumb>
    </div>
    <!-- 面包屑导航 teamManage -->
    <!-- 添加团队 -->
    <div class="content">
      <h2>短链管理</h2>
      <h3>数据筛选</h3>
      <div>
        <el-form :inline="true" id="search" size="small">
          <el-form-item label="名称">
            <el-input
                v-model="search.name"
                clearable
                placeholder="请输入名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="编码">
            <el-input
                v-model="search.mappingKey"
                clearable
                placeholder="请输入编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="原始长链接">
            <el-input
                v-model="search.longLink"
                clearable
                placeholder="请输入原始长链接"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
                v-model="search.status"
                placeholder="请选择状态"
                clearable
            >
              <el-option
                  v-for="item in dictionaries.short_link_mapping_status"
                  :key="item.dictId"
                  :label="item.dictName"
                  :value="item.dictId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker v-model="search.createdTime" type="daterange" unlink-panels clearable range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            @change="onChangeCreatedData"
                            value-format="yyyy-MM-dd">
              >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
            >查询
            </el-button
            >
            <el-button
                type="primary"
                plain
                @click="fetchData('reset')"
            >重置
            </el-button
            >
          </el-form-item
          >
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3 class="data-list-title">
        数据列表
        <el-button
            v-if="parArray.indexOf('shortLinkEdit') != -1"
            size="small"
            type="primary"
            @click="showDialog('新增', 'add')"
        >新增
        </el-button
        >
      </h3>

      <!-- <div>{{ parArray.indexOf("authorityAdd") == 1 }}{{ parArray }}</div> -->
      <lb-table
          :column="column"
          :data="dataList"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
      >
      </lb-table>
    </div>
    <!-- 管理客户等级 -->

    <!-- ============================= el-dialog ============================= -->
    <el-dialog
        :title="dialog.title"
        :visible.sync="dialog.visible"
        width="30%"
        :append-to-body="true"
        :before-close="handleClose"
        class="shop-dialog"
    >
      <div class="dialog-content">
        <div>
          <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" size="mini" maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-radio-group v-model="form.type">
                <el-radio label="0">链接</el-radio>
                <el-radio label="1">小程序</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="小程序" prop="appId" v-if="form.type == '1'">
              <el-select
                  v-model="form.appId"
                  placeholder="请选择小程序"
                  clearable
              >
                <el-option
                    v-for="item in dictionaries.mini_app_name"
                    :key="item.dictId"
                    :label="item.dictName"
                    :value="item.dictId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="原始长链接" prop="sourceUrl">
              <el-input type="textarea" v-model="form.sourceUrl" size="mini" maxlength="400" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="启用时间" prop="enableTime">
              <el-date-picker
                  v-model="form.enableTime"
                  type="datetime"
                  placeholder="选择启用时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="00:00:00">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="禁用时间" prop="disableTime">
              <el-date-picker
                  v-model="form.disableTime"
                  type="datetime"
                  placeholder="选择禁用时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="允许访问次数" prop="allowTotal">
              <el-input v-model="form.allowTotal" size="mini" type="number"></el-input>
            </el-form-item>
            <el-form-item label="访问密码" prop="accessPassword">
              <el-input v-model="form.accessPassword" size="mini" maxlength="20" show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" @click="dialogConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <!-- ============================= el-dialog end ============================= -->
  </div>
</template>

<script>
import {checkCode, checkSort} from '@/utils/rules.js';
import LbTable from '../../../components/lb-table/lb-table'

export default {
  name: 'role',
  components: {LbTable},
  data() {
    return {
      search: {
        name: '', // 名称
        mappingKey: '', // 编码
        longLink: '', // 原始长链接
        status: null, // 状态：0 正常、1 禁用、2 过期、3 受限
        createdTime: [], // 创建时间-开始
        createdTimeStart: '', // 创建时间-开始
        createdTimeEnd: '' // 创建时间-结束
      },
      dataList: [], // 店铺列表
      column: [
        {label: '编码', prop: 'mappingKey'},
        {label: '名称', prop: 'name'},
        {
          label: '短链', render: (h, scope) => {
            return (<span onClick={() => this.copyString(scope.row.linkUrl)}>{scope.row.linkUrl}</span>)
          }
        },
        {label: '访问密码', prop: 'accessPassword'},
        {label: '允许访问次数', prop: 'allowTotal'},
        {
          label: '跳转内容', render: (h, scope) => {
            if (scope.row.type == '1') {
              return (<div>
                <p>【小程序】{scope.row.appName}</p>
                <p>{scope.row.longLink}</p>
              </div>)
            } else if (scope.row.longLink.startsWith('https://wxaurl') && scope.row.appDaysLeft <= 0) {
              return (<div>
                <p>【小程序】{scope.row.appName}</p>
                <p>{scope.row.longLink}</p>
                <p>（已失效）</p>
              </div>)
            } else if (scope.row.longLink.startsWith('https://wxaurl')) {
              return (<div>
                <p>【小程序】{scope.row.appName}</p>
                <p>{scope.row.longLink}</p>
                <p title='有效时间'>（{scope.row.appDaysLeft}天）</p>
              </div>)
            } else {
              return (<p>{scope.row.longLink}</p>)
            }
          }
        },
        {
          label: 'PV/UV', render: (h, scope) => {
            return (<div><p>{scope.row.pv}/{scope.row.uv}</p>
              <p>
                <el-link size="mini" type="primary"
                      className={this.parArray.indexOf('shortLinkEdit') != -1 ? 'info' : 'hide-content'}
                      onClick={() => {
                        this.onDownAccessRecords(scope.row, scope.$index)
                      }}>下载
                </el-link>
              </p>
            </div>)
          }
        },
        {label: '状态', prop: 'statusLabel'},
        {label: '启用时间', prop: 'enableTime'},
        {label: '禁用时间', prop: 'disableTime'},
        {label: '创建时间', prop: 'createdTime'},
        {
          label: '操作',
          render: (h, scope) => {
            return (
                <div>
                  <el-link size="mini" type="danger"
                           class={this.parArray.indexOf('shortLinkEdit') != -1 ? 'info' : 'hide-content'}
                           onClick={() => {
                             this.onDelete(scope.row, scope.$index)
                           }}>删除
                  </el-link>
                </div>
            )
          }
        }],
      page: {pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1},
      dialog: {visible: false, title: "编辑", type: ''},
      form: {
        name: '', // 名称
        type: '0', // 类型
        appId: '', // 应用id
        sourceUrl: '', // 原始长链接URL
        enableTime: '', // 启用时间
        disableTime: '', // 禁用时间
        allowTotal: null, // 允许访问次数
        accessPassword: '' // 访问密码
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
          {min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur'}
        ],
        appId: [
          {required: true, message: '请选择小程序', trigger: 'blur'}
        ],
        sourceUrl: [
          {required: true, message: '请输入原始长链接', trigger: 'blur'},
          {min: 1, max: 400, message: '长度在 1 到 400 个字符', trigger: 'blur'}
        ],
        accessPassword: [
          {min: 0, max: 400, message: '长度在 0 到 20 个字符', trigger: 'blur'}
        ]
      },
      dictionaries: { // 字典数据
        short_link_mapping_status: [], // 状态
        mini_app_name: []
      },
      parArray: [] // 按钮权限
    }
  },
  created() {
    this.fetchData()
    this.getButtonTreeDto() // 获取权限设定
    // 获取字典值
    for (const dictionary in this.dictionaries) {
      this.getDictionaries(dictionary)
    }
  },
  /*
  watch: {
    permissionFilterText (val) {
      this.$refs.tree.filter(val);
    }
  },
  */
  methods: {
    fetchData(type) {
      if (type == 'reset') {
        this.search = {
          name: '', // 名称
          mappingKey: '', // 编码
          longLink: '', // 原始长链接
          status: null, // 状态：0 正常、1 禁用、2 过期、3 受限
          createdTime: [],
          createdTimeStart: '', // 创建时间-开始
          createdTimeEnd: '' // 创建时间-结束
        }
        this.page.pageNo = 1
        this.page.pageSize = 10
        this.page.currentPage = 1
      }
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      if (type == 'search') {
        this.page.currentPage = 1
        this.page.pageNo = 1
        params.pageNo = 1
        const search = this.search
        params = Object.assign(params, search);
        // 去除字符串 前后 空格
        for (let item in params) {
          if (typeof params[item] === "string") {
            params[item] = params[item].trim()
          }
        }
      }
      this.$api.linksPageList(params).then((res) => {
        if (res.code === 0) {
          this.dataList = res.data.list
          this.page.totalNum = res.data.totalNum
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    onChangeCreatedData(time) {
      if (time) {
        this.search.createdTimeStart = time[0]
        this.search.createdTimeEnd = time[1]
      } else {
        this.search.createdTimeStart = ''
        this.search.createdTimeEnd = ''
      }
    },
    handleCurrentChange(currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
          (item) => item.menuCode === 'shortLinkPageCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) {
        return
      }
      const params = {groupId: type}
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 显示  dialog
    showDialog(title, type, row) {
      // console.log(title, type, row)
      this.dialog.type = type
      this.currentRow = row
      if (type == 'edit') {
        if (this.parArray.indexOf('shortLinkEdit') == -1) {
          return this.$message({type: 'warning', message: '没有权限请联系管理员!'});
        }
        this.dialog.visible = true;
        this.dialog.title = '编辑'
        this.form = row
        this.onChangeEditClassId(row.classId)
      }
      if (type == 'add') {
        if (this.parArray.indexOf('shortLinkEdit') == -1) {
          return this.$message({type: 'warning', message: '没有权限请联系管理员!'});
        }
        this.dialog.visible = true;
        this.dialog.title = '新增'
        this.form = {
          name: '', // 名称
          type: '0', // 类型
          appId: '', // 应用id
          sourceUrl: '', // 原始长链接URL
          enableTime: '', // 启用时间
          disableTime: '', // 禁用时间
          allowTotal: null, // 允许访问次数
          accessPassword: '' // 访问密码
        }
      }
      this.$refs["form"].resetFields();
    },
    // 修改 回显 classId
    onChangeEditClassId(classId) {
      console.time("回显 classId", classId)
      const categoryList = this.categoryList
      if (categoryList.length < 0) {
        console.log("categoryList没到位！", categoryList)
      }
      let arr = []
      categoryList.forEach((firstItem, firstIndex) => {
        if (firstItem.id === classId) {
          arr.push(firstItem.id)
          return
        }
        if (firstItem.children) {
          firstItem.children.forEach((secondItem, secondIndex) => {
            if (secondItem.id === classId) {
              arr.push(firstItem.id)
              arr.push(secondItem.id)
              return
            }
            if (secondItem.children) {
              secondItem.children.forEach((thirdItem, thirdIndex) => {
                if (thirdItem.id === classId) {
                  arr.push(firstItem.id)
                  arr.push(secondItem.id)
                  arr.push(thirdItem.id)
                  return
                }
              }) // third end
            }
          }) // second end
        }
      }) // first end
      this.form.classId = arr
      console.timeEnd("回显 classId")
    },
    // 修改 classId
    onChangeClassId(e) {
      console.log(e)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    // 确认后判断各类操作
    dialogConfirm() {
      const type = this.dialog.type
      switch (type) {
        case 'add':
          this.submitForm('form', "add")
          break;
        case 'edit':
          this.submitForm('form', "edit")
          break;
        default:
          console.log(type)
      }
    },
    // 表单验证
    submitForm(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.addPermissionForm.name)
          if (type === "edit") {
            return this.editShop()
          }
          this.addShortLink()
          // console.log('submit!', valid, this.addPermissionForm.name);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 添加短链
    addShortLink() {
      const params = this.form
      this.$api.addShortLinks(params).then((res) => {
        if (res.code === 0) {
          this.form = {
            name: '', // 名称
            type: '0', // 类型
            appId: '', // 应用id
            sourceUrl: '', // 原始长链接URL
            enableTime: '', // 启用时间
            disableTime: '', // 禁用时间
            allowTotal: null, // 允许访问次数
            accessPassword: '' // 访问密码
          }
          this.dialog.visible = false;
          this.fetchData()
          this.$message({type: 'success', message: '操作成功!'});
        }


      }).catch((err) => {
        this.form.status = this.dictionaries.enable_status.find((e) => e.dictId == params.status || e.dictName == params.status).dictName
        console.log(err)
      })
    },
    // 编辑
    editShop() {
      const params = this.form
      // if (typeof params.status !== Number) { params.status = this.dictionaries.enable_status.find((e) => e.dictName === params.status).dictId }
      // console.log(params)
      // const params = { name: permissionForm.name, dataPermission: permissionForm.dataPermission, salesAuthorityId: permissionForm.salesAuthorityId }
      params.classId = this.form.classId[this.form.classId.length - 1]
      this.$api.shopUpdate(params).then((res) => {
        if (res.code === 0) {
          this.dialog.visible = false;
          this.fetchData()
          this.$message({type: 'success', message: '编辑成功!'});
        }
      }).catch((err) => {
        this.fetchData()
        console.log(err)
      })
    },
    // 删除
    onDelete(item, index) {
      if (this.parArray.indexOf('shortLinkEdit') == -1) {
        return this.$message({type: 'warning', message: '没有权限请联系管理员!'});
      }
      this.$confirm('此操作将删除选中的短链, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {id: item.id}
        this.$api.deleteShortLinks(data).then((res) => {
          this.fetchData()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 下载
    onDownAccessRecords (item, index) {
      this.$confirm('此操作将下载链接的访问记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = { ids: [item.id] }
        this.$api.exportAccessList(data).then((res) => {
          if (res.code === 0) {
            // 下载
            this.downloadlink(res.data)
          } else {
            this.$message.error('下载失败')
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消下载'
        });
      });
    },
    // 修改状态
    changeStatus(item, index) {
      const data = {id: item.id}
      // 禁用
      if (item.status === 1) {
        if (this.parArray.indexOf("storeDisabled") == -1) {
          return this.$message({type: 'warning', message: '没有权限请联系管理员!'});
        }

        this.$api.shopDisable(data).then((res) => {
          this.fetchData()
          this.$message({
            message: `已禁用【${item.name}】!`
          });
        }).catch((err) => {
          console.log(err)
        })
      }

      // 启用
      if (item.status === 2) {
        if (this.parArray.indexOf("openStore") == -1) {
          return this.$message({type: 'warning', message: '没有权限请联系管理员!'});
        }

        this.$api.shopEnable(data).then((res) => {
          this.fetchData()
          this.$message({
            type: 'success',
            message: `启用【${item.name}】成功!`
          });
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      this.search.classId = val[val.length - 1]
      console.log(val, this.search.classId)
    },
    // 复制 KSU
    copyString(info) {
      // console.log('onCopySku', info)
      const t = this
      this.$copyText(info).then(
          function (e) {
            t.$message({
              type: 'success',
              message: '复制成功'
            })
          },
          function (e) {
            t.$message({
              type: 'warning',
              message: '复制失败'
            })
          }
      )
    },
  }
}
</script>

<style scoped lang="scss">
.div1 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb2.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

.div2 {
  margin-left: -16px;
  background: url(../../../assets/breadcrumb1.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
}

.div3 {
  margin-left: -8px;
  background: url(../../../assets/breadcrumb3.png);
  width: 120px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2d7edf;
}

//
//#search{
//  display: flex;
//  .el-form-item{
//    flex: 1;
//    .el-form-item__content{
//      width: 80%;
//    }
//  }
//}

.content {
  .el-button {
    margin-bottom: 10px;
  }

  .el-badge {
    margin-left: 10px;
  }
}

.roleList {
  border: 1px solid #f0f3fd;
  border-radius: 5px;

  .title {
    color: #333333;
    line-height: 40px;
    padding: 0 10px;
    background-color: #f0f3fd;

    .el-badge {
      margin-top: 10px;
      margin-left: 10px;
    }
  }

  .list {
    padding: 20px;

    .el-tag {
      border: 0;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}

.dialog-content {
  // min-height: 210px;
  .el-tree {
    max-height: 300px;
    overflow: auto;
  }

  .el-radio {
    // display: block;
    // margin: 8px 0;
  }
}

/deep/ .hide-content {
  display: none !important;
}
</style>
<style lang="scss">
.content {
  .el-link {
    margin: 0 5px;
  }

  h4 {
    padding-top: 10px;
    border-top: 1px solid #bbbbbb;
  }
}
</style>
